import { Link, useLocation } from "react-router-dom";

const Missing = () => {
  const location = useLocation();
  return (
    <article
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      <h1>אופס!</h1>
      <p>אין לך הרשאה מתאימה</p>
      <p style={{ color: "red", fontSize: "0.9rem" }}>
        הדף <code>{location.pathname}</code> לא נמצא
      </p>
      <div className="flexGrow">
        <Link to="/">דף הבית</Link>
      </div>
    </article>
  );
};

export default Missing;
